import { useTheme } from "@mui/material/styles";
import { useContext, useState } from "react";
import { styled } from "@mui/material/styles";
import Highlight from "components/ui/atoms/Highlight";
import { useGoogleLogin } from "@react-oauth/google";
import {
  AuthenticationContext,
  SCOPES,
} from "components/context/AuthenticationProvider";
import { Typography } from "@mui/material";

const LoginPageContainer = styled("div")(({ theme }) => ({
  display: "flex",
  height: "100vh",
  justifyContent: "center",
  backgroundColor: theme.palette_custom.darkBlue,
}));

const Button = styled("span")(({ theme }) => ({
  margin: "auto",
  color: theme.palette_custom.yellow,
  fontSize: theme.fontSize.lg,
  textAlign: "center",
  textDecoration: "none",
  "&:hover": {
    color: theme.palette_custom.white,
    cursor: "pointer",
  },
}));

const LoginPage = ({}) => {
  const theme = useTheme();
  const [error, setError] = useState("");
  const { loginFromCode } = useContext(AuthenticationContext);

  const login = useGoogleLogin({
    flow: "auth-code",
    onSuccess: (tokenResponse) => {
      loginFromCode(tokenResponse.code);
    },
    onError: (error) => {
      setError(error);
    },
    overrideScope: true,
    include_granted_scopes: false,
    scope: SCOPES,
  });

  return (
    <LoginPageContainer>
      <Button onClick={() => login()}>
        <Highlight color={theme.palette_custom.lightGreen}>
          Enter the orbit.
        </Highlight>
        {error && <Typography>{JSON.stringify(error)}</Typography>}
      </Button>
    </LoginPageContainer>
  );
};

export default LoginPage;
